import {
  Box,
  css,
  Flex,
  Heading,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';

import { ReferralLinkTabContent } from './ReferralLinkTabContent';
import { ReferralWidgetTabContent } from './ReferralWidgetTabContent';
import { useRef } from 'react';
import { scrollElementToCenter } from 'src/utils/scrollElementToCenter';

const tabs = [
  {
    name: 'Enviar link',
    content: <ReferralLinkTabContent />,
  },
  {
    name: 'Incluir botão no meu site',
    content: <ReferralWidgetTabContent />,
  },
];

export const ReferralTabs = () => {
  const scrollerRef = useRef();

  const handleScrollClick = event => {
    const scroller = scrollerRef.current;
    const targetElement = event.target;
    scrollElementToCenter(scroller, targetElement);
  };

  return (
    <>
      <Heading mb={5} fontSize={{ base: 'md', lg: '2xl' }}>
        Use as opções abaixo para fazer suas indicações
      </Heading>

      <Box
        className="tabs_wrapper"
        borderRadius="md"
        border="1px solid"
        borderColor="gray.200"
      >
        <Tabs isFitted>
          <Flex
            overflowX="auto"
            ref={scrollerRef}
            css={css({
              scrollbarWidth: 'none',
              '::-webkit-scrollbar': { display: 'none' },
              WebkitOverflowScrolling: 'touch',
            })}
            pos="relative"
          >
            <TabList
              minH={{ base: '48px', md: '72px' }}
              flex={1}
              px={{ base: 4, md: 14 }}
            >
              {tabs.map(tab => (
                <Tab
                  whiteSpace="nowrap"
                  onClick={handleScrollClick}
                  key={`tab-${tab.name}`}
                  fontWeight="bold"
                >
                  {tab.name}
                </Tab>
              ))}
            </TabList>
          </Flex>

          <TabPanels>
            {tabs.map(tab => (
              <TabPanel
                data-tabname={tab.name}
                px={{ base: 4, md: 14 }}
                py={{ base: 14, md: 20 }}
                key={`tab_content-${tab.name}`}
              >
                {tab.content}
              </TabPanel>
            ))}
          </TabPanels>
        </Tabs>
      </Box>
    </>
  );
};
